import React, { forwardRef, memo, useCallback, useEffect, useImperativeHandle, useRef, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-material.css';
import '../styles/style.css';
import arrowIcon from '../../../../../assets/icons/svg/arrow-icon.svg';
import moment from "moment";
// import { useHistory } from "react-router-dom";
import { Button, Icon, Select, Spin } from "antd";
import { BOBADMIN, EA, getNameInitials, REVIEWADMIN } from "../../../../../utils/Constants";
import { GET_GRID_CARD_ROWDATA } from "./RS-FS-Admin-Buckets";
import axios from "axios";
import {
    GET_RS_LEADERBOARD,
    // GET_RS_ADMIN_AGENCYS, GET_FS_ADMIN_AGENCYS,
    // GET_RS_ADMIN_USER_STATS,
    // GET_FS_ADMIN_USER_STATS,
    // GET_RS_OTHER_STATISTICS_PIE,
    // GET_SUB_TYPE_OF_CALL_STATS,
    // GET_RS_OTHER_STATISTICS_PIE_1,
    // GET_FS_CALL_ACTION_STATS,
    // GET_FS_ADMIN_DASHBOARD_APPOINTMENT_STATS,
    // GET_RS_APPOINTMENT_STATS,
    // GET_TYPE_OF_CALL_STATS,
    GET_FS_LEADERBOARD, GET_VONBOARD_DROPDOWN_USERS_LIST, GET_REVIEWADMIN_DROPDOWN_USERS_LIST
} from "../../../../../utils/Api_enums";
import { useBoundStore } from "../../../../../store/useBoundStore";
import UserStatsModal from "../UserStatsModal";


const { Option } = Select;


//PROGRESS BAR
const ProgressBarRenderer = memo((props) => {



    const getProgressColor = (total_dials = 0, totalApp = 0) => {
        const progressValue = total_dials + totalApp;

        let color = '';
        if (progressValue < 80) {
            color = 'red';
        } else if (progressValue <= 160) {
            color = 'orange';
        } else {
            color = 'green';
        }

        return { value: progressValue, color };
    }


    const { name, progress, total_dials, totalApp } = props.data;
    const progressValue = getProgressColor(total_dials, totalApp);


    return (
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <div>
                {/* <Avatar
                    src={"https://api.dicebear.com/7.x/miniavs/svg?seed=1"}
                    className="custom-avatar"
                /> */}
                {/* remove default image showing name initials now  */}
                <span
                    style={{
                        marginRight: 10,
                        color: "rgb(22, 72, 151)",
                        background: '#F0F2F5',
                        borderRadius: "50%",
                        padding: "5px",
                        fontWeight: "600",
                        fontFamily: "Poppins"
                    }} >
                    {getNameInitials(`${name}`)}
                </span>

            </div>
            <div style={{ flex: 0.7 }}>{name}</div>

            <div style={{
                width: "55px", height: "6px", flexShrink: 0,
                backgroundColor: "#e0e0e0", borderRadius: "4px", overflow: "hidden"
            }}>
                <div
                    style={{
                        width: `${100}%`,
                        height: "100%",
                        backgroundColor: progressValue.color,
                        transition: "width 0.3s ease-in-out",
                    }}
                />
            </div>
        </div>
    );
});


//ARROW ICON
const ArrowIconRenderer = memo((props) => {
    const [callCounts, setCallCounts] = useState(props.data.data);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;
    const [loading, setLoading] = useState(true);
    const { setRSFSFilters, RSFSCardFilters } = useBoundStore();

    const handleIconClick = () => {
        localStorage.removeItem('callCounts');
        localStorage.removeItem('card');
        const initialDateRange = {
            start_date: RSFSCardFilters.datemodified.start_date || "2010-01-01",
            end_date: RSFSCardFilters.datemodified.end_date || "2050-01-01",
        };
        setRSFSFilters({
            datemodified: initialDateRange,
            selectedButton: 'AllBFiles'
        });
        setIsModalOpen(true);
        //updateCallsCount(props.data.id, props.data.data, props.data.userType);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };



    useEffect(() => {
        setCallCounts(props.data.data);
    }, [props.data.id]);

    const routeToRSFSGrid = (item, userName) => {
        if (item.isClickable) {
            setRSFSFilters({ searchText: '', page: 1, selectedAgency: undefined })
            item.userName = userName;
            // item.role = props.context.customUserType;
            localStorage.setItem("card", JSON.stringify(item));
            localStorage.setItem("customUserType", props.context.customUserType);


            props.context.props.history.push({
                pathname: "/dashboard/rsfs-grid",
                search: `?title=${encodeURIComponent(item.title)}`,
                state: { card: item }
            });
        }
    };

    const Route = () => {
        props.context.props.history.push("/admin");
    };

    return (
        <div>
            <span
                role="button"
                tabIndex="0"
                onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        handleIconClick();
                    }
                }}
                onClick={handleIconClick} style={{ cursor: "pointer" }}
                aria-label="Toggle arrow"
            >
                <img src={arrowIcon} alt="Arrow Icon" />
            </span>


            <UserStatsModal
                visible={isModalOpen}
                onClose={handleCloseModal}
                userData={props.data}
                onCardClick={routeToRSFSGrid}
            />
        </div >
    );
});

//GRID
const ReusableAgGrid = forwardRef(({ rowData, columnDefs, gridOptions,
    props, customUserType, datemodified }, ref) => {
    const gridApiRef = React.useRef(null);
    const [extraProps, setExtraProps] = useState();
    const [gridApi, setGridApi] = useState(null);
    const [columnApi, setColumnApi] = useState(null);

    const onGridReady = useCallback((params) => {
        gridApiRef.current = params.api;
        setGridApi(params.api);
        setColumnApi(params.columnApi);

        const savedState = localStorage.getItem("agGridColumnState");
        if (savedState) {
            params.columnApi.applyColumnState({
                state: JSON.parse(savedState),
                applyOrder: true,
            });
        }

        //params.api.sizeColumnsToFit();
    }, []);



    useImperativeHandle(ref, () => ({
        resetGridState: () => {
            localStorage.removeItem("agGridColumnState");
            if (columnApi) {
                columnApi.resetColumnState();
                columnApi.resetColumnGroupState();
            }
        }
    }));


    const saveState = useCallback((params) => {
        const state = params.columnApi.getColumnState();
        localStorage.setItem("agGridColumnState", JSON.stringify(state));
    }, []);

    const defaultColDef = {
        flex: 1,
        resizable: true,
        sortable: true,
        filter: false,
        minWidth: 200,
    };

    return (
        <div className="ag-theme-material" style={{ height: "500px", width: "100%", overflowX: "auto" }}>
            <AgGridReact
                rowData={rowData}
                columnDefs={columnDefs}
                defaultColDef={defaultColDef}
                frameworkComponents={{
                    progressBarRenderer: ProgressBarRenderer,
                    arrowIconRenderer: ArrowIconRenderer,
                }}
                onColumnMoved={saveState}
                onSortChanged={saveState}
                onFilterChanged={saveState}
                context={{ props, customUserType, datemodified }}
                onGridReady={onGridReady}
                {...gridOptions}
                suppressRowClickSelection={true}
                overlayNoRowsTemplate=""
                overlayLoadingTemplate=""
                suppressNoRowsOverlay={true}
                suppressCellSelection={true}
            />
        </div>
    );
});


//LEADER BOARD
const LeaderBoard =
    forwardRef(({
        user,
        setUsers,
        setFollowUpAdminUsers,
        props,
        setUserPage,
        userType,
        agencies,
        followUpAdminUsers,
        datemodified }, ref) => {
        const { resetRSFSCardFilters, RSFSCardFilters, setRSFSCardFilters } = useBoundStore();
        const [rowDataReviewAdmin, setRowDataReviewAdmin] = useState([]);
        const [rowDataFollowUP, setRowDataFollowUP] = useState([]);
        const [selectedAgencies, setSelectedAgencies] = useState(RSFSCardFilters.selectedLeaderBoardAgency);
        const [selectedUsers, setSelectedUsers] = useState(RSFSCardFilters.selectedLeaderBoardUsers);

        const [userOptions, setUserOptions] = useState([]);
        const [searchText, setSearchText] = useState('');
        const [fetching, setFetching] = useState(false);

        const [loading, setLoading] = useState(false);
        const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;

        useImperativeHandle(ref, () => ({
            refreshFilters
        }));

        const handleUserPillRemove = (user) => {
            const newSelected = selectedUsers.filter(u => u.key !== user.key);
            setSelectedUsers(newSelected);
            const userIds = newSelected.map(u => u.key);
            handleChange(userIds.length ? userIds : [], "User");
        }




        const fetchUsersFS = async (search) => {
            let type = "all";
            setFetching(true);
            try {
                const response = await axios.get(`${GET_VONBOARD_DROPDOWN_USERS_LIST}?rolename_param=${type}&search=${search}`);
                setUserOptions(response.data && response.data["Virtual On-Boarding1"] || []);
            } catch (err) {
                console.error('Failed to fetch users:', err);
                setUserOptions([]);
            }
            setFetching(false);
        };





        const fetchUsersRS = async (search) => {
            setFetching(true);
            try {
                const response = await axios.get(`${GET_REVIEWADMIN_DROPDOWN_USERS_LIST}?&search_text=${search}`);
                setUserOptions(response.data && response.data.data);
            } catch (err) {
                console.error('Failed to fetch users:', err);
                setUserOptions([]);
            }
            setFetching(false);
        };



        useEffect(() => {
            const delayDebounce = setTimeout(() => {
                if (searchText) {
                    if (userType == REVIEWADMIN) {
                        fetchUsersRS(searchText);
                    } else {
                        fetchUsersFS(searchText);
                    }
                }
            }, 500);

            return () => clearTimeout(delayDebounce);
        }, [searchText]);


        useEffect(() => {
            if (userType === REVIEWADMIN) {
                fetchFilteredUsersByAgencyForRSLeaderBoard(selectedAgencies, selectedUsers);
            }
        }, [selectedAgencies, selectedUsers, RSFSCardFilters.hideBadPhoneNumber]);

        useEffect(() => {
            if (userType == EA) {
                fetchFilteredUsersByAgencyForFSLeaderBoard(selectedAgencies, selectedUsers);
            }
        }, [selectedAgencies, selectedUsers, RSFSCardFilters.hideBadPhoneNumber]);



        const fetchFilteredUsersByAgencyForFSLeaderBoard = async (agencyId, selectedUsers) => {
            setLoading(true);
            let queryParts = [
                `user_type=${BOBADMIN}`,
                `start_date=${datemodified.start_date}`,
                `end_date=${datemodified.end_date}`,
                `page=1`
            ];

            if (RSFSCardFilters.hideBadPhoneNumber === undefined || RSFSCardFilters.hideBadPhoneNumber) {
                queryParts.push("bad_phone_number_status=false");
            }

            if (agencyId) {
                queryParts.push(`agency_id=${agencyId}`);
            }

            if (selectedUsers && selectedUsers.length > 0) {
                const userIdsQuery = selectedUsers.map(u => `user_id=${u.key}`).join("&");
                queryParts.push(userIdsQuery);
            }

            const queryString = queryParts.join("&");

            try {
                const response = await axios.get(`${GET_FS_LEADERBOARD}?${queryString}`);
                const followUpUsers = (response.data && response.data.data) || [];



                setRowDataFollowUP(
                    followUpUsers.map(user => ({
                        id: user.id,
                        name: user.name,
                        start_date: user.start_date,
                        end_date: user.end_date,
                        totalApp: user.total_appointments,
                        total_dials: user.total_dials || 0,
                        progress: 0,
                        change: 0,
                        userType: userType,
                        data: GET_GRID_CARD_ROWDATA(userType),
                    }))
                );

                setFollowUpAdminUsers(followUpUsers);

            } catch (error) {
                console.error("Failed to fetch filtered leaderboard users", error);
            } finally {
                setLoading(false);
            }
        };



        const fetchFilteredUsersByAgencyForRSLeaderBoard = async (agencyId, selectedUsers) => {
            setLoading(true);
            let queryParts = [
                `user_type=${userType}`,
                `start_date=${datemodified.start_date}`,
                `end_date=${datemodified.end_date}`,
                `page=1`
            ];

            if (RSFSCardFilters.hideBadPhoneNumber === undefined || RSFSCardFilters.hideBadPhoneNumber) {
                queryParts.push("bad_phone_number_status=false");
            }

            if (agencyId) {
                queryParts.push(`agency_id=${agencyId}`);
            }


            if (selectedUsers && selectedUsers.length > 0) {
                const userIdsQuery = selectedUsers.map(u => `user_id=${u.key}`).join("&");
                queryParts.push(userIdsQuery);
            }

            const queryString = queryParts.join("&");

            try {
                const response = await axios.get(`${GET_RS_LEADERBOARD}?${queryString}`);
                const users = (response.data && response.data.data) || [];

                setRowDataReviewAdmin(
                    users.map(user => ({
                        id: user.id,
                        name: user.name,
                        totalApp: user.total_appointments,
                        total_dials: user.total_dials || 0,
                        progress: 0,
                        change: 0,
                        userType: userType,
                        start_date: user.start_date,
                        end_date: user.end_date,
                        data: GET_GRID_CARD_ROWDATA(userType),
                    }))
                );

                setUsers(users);



            } catch (error) {
                console.error("Failed to fetch filtered leaderboard users", error);
            } finally {
                setLoading(false);
            }
        };




        useEffect(() => {
            if (userType == REVIEWADMIN) {
                setRowDataReviewAdmin(
                    user.map(user => ({
                        id: user.id,
                        name: user.name,
                        totalApp: user.total_appointments,
                        total_dials: user.total_dials || 0,
                        progress: 0,
                        change: 0,
                        userType: userType,
                        start_date: user.start_date,
                        end_date: user.end_date,
                        data: GET_GRID_CARD_ROWDATA(userType),
                    }))
                );
            } else {
                setRowDataFollowUP(
                    followUpAdminUsers.map(user => ({
                        id: user.id,
                        name: user.name,
                        start_date: user.start_date,
                        end_date: user.end_date,
                        totalApp: user.total_appointments,
                        total_dials: user.total_dials || 0,
                        progress: 0,
                        change: 0,
                        userType: userType,
                        data: GET_GRID_CARD_ROWDATA(userType),
                    }))
                );
            }
        }, [userType, user, followUpAdminUsers]);


        useEffect(() => {
            if (gridRef.current) {
                // gridRef.current.resetGridState(); // 
            }
        }, []);



        const gridRef = useRef(null);

        const refreshFilters = () => {




            if (gridRef.current) {
                gridRef.current.resetGridState();
            }



            setRSFSCardFilters({
                selectedLeaderBoardAgency: undefined,
                selectedLeaderBoardUsers: []
            })
            let dataFilter = (userType == REVIEWADMIN) ? user : followUpAdminUsers;
            setUserOptions([]);
            setSelectedAgencies([]);
            setSelectedUsers([]);
            setUserPage(1);
            const allUsers = dataFilter.map(user => ({
                id: user.id,
                name: user.name,
                start_date: user.start_date,
                end_date: user.end_date,
                total_dials: user.total_dials || 0,
                progress: 0,
                totalApp: user.total_appointments,
                change: 0,
                data: GET_GRID_CARD_ROWDATA(userType),
            }));
            if (userType == REVIEWADMIN) {
                setRowDataReviewAdmin(allUsers);
            } else {
                setRowDataFollowUP(allUsers)
            }
        };




        const handleChange = (selectedIds, type) => {
            if (!Array.isArray(selectedIds) || !user) return;

            let filteredRowData = [];

            let dataFilter = (userType == REVIEWADMIN) ? user : followUpAdminUsers;

            if (type === 'User') {
                if (selectedIds.length === 0) {
                    setSelectedUsers([]);
                    filteredRowData = dataFilter.map(user => ({
                        id: user.id,
                        name: user.name,
                        start_date: user.start_date,
                        end_date: user.end_date,
                        total_dials: user.total_dials || 0,
                        progress: 0,
                        totalApp: user.total_appointments,
                        change: 0,
                        data: GET_GRID_CARD_ROWDATA(userType),
                    }));
                } else {
                    // Filter users based on selected user IDs
                    filteredRowData = dataFilter.filter(user => selectedIds.includes(user.id)).map(user => ({
                        id: user.id,
                        name: user.name,
                        start_date: user.start_date,
                        end_date: user.end_date,
                        total_dials: user.total_dials || 0,
                        progress: 0,
                        totalApp: user.total_appointments,
                        change: 0,
                        data: GET_GRID_CARD_ROWDATA(userType),
                    }));
                }
            } else {
                // If no agency is selected, return all users
                if (selectedIds.length === 0) {
                    setSelectedAgencies([]);
                    filteredRowData = dataFilter.map(user => ({
                        id: user.id,
                        name: user.name,
                        start_date: user.start_date,
                        end_date: user.end_date,
                        total_dials: user.total_dials || 0,
                        progress: 0,
                        totalApp: user.total_appointments,
                        change: 0,
                        data: GET_GRID_CARD_ROWDATA(userType),
                    }));
                } else {
                    // Filter users based on selected agency IDs
                    filteredRowData = dataFilter
                        .filter(user => user.agency_ids.some(id => selectedIds.includes(id))) // Safety check for agency_ids
                        .map(user => ({
                            id: user.id,
                            name: user.name,
                            start_date: user.start_date,
                            end_date: user.end_date,
                            total_dials: user.total_dials || 0,
                            progress: 0,
                            totalApp: user.total_appointments,
                            change: 0,
                            data: GET_GRID_CARD_ROWDATA(userType),
                        }));
                }
            }

            if (userType == REVIEWADMIN) {
                setRowDataReviewAdmin(filteredRowData);
            } else {
                setRowDataFollowUP(filteredRowData)
            }

        };








        // Define columnDefs for BOB and REVIEWADMIN
        const columnDefsFollowUp = [
            { field: "name", headerName: "Follow-Up Specialist", cellRenderer: "progressBarRenderer", flex: 2, sortable: true },
            { field: "total_dials", headerName: "Dials Made", flex: 1 },
            { field: "totalApp", headerName: "Total Scheduled Appointments", flex: 1.5 },
            {
                field: "action",
                headerName: "Action",
                cellRenderer: "arrowIconRenderer",
                flex: 0.5
            },
        ];

        const columnDefsReviewAdmin = [
            { field: "name", headerName: "Review Scheduler", cellRenderer: "progressBarRenderer", flex: 2, sortable: true },
            { field: "total_dials", headerName: "Dials Made", flex: 1 },
            { field: "totalApp", headerName: "Total Scheduled Appointments", flex: 1.5 },
            { field: "action", headerName: "Action", cellRenderer: "arrowIconRenderer", flex: 0.5 },
        ];

        const rowData = userType === EA ? rowDataFollowUP : rowDataReviewAdmin;
        const columnDefs = userType === EA ? columnDefsFollowUp : columnDefsReviewAdmin;
        const title = userType === EA ? "Follow-Up Specialist Leaderboard" : "Review Scheduler Leaderboard";
        const placeholder = userType === EA ? "Search Follow-Up Specialist" : "Search Review Scheduler";

        localStorage.setItem('buckets', JSON.stringify(GET_GRID_CARD_ROWDATA(userType)));


        return (
            <div>
                <div className="review-scheduler-leaderboard-header" >
                    <div className="title-Date title-container">
                        <h2 className="color-primary mt-20 mb-5 fw-600">{title}</h2>
                        <p className='custom-text-dark'>
                            {moment(datemodified.start_date).format("MM/DD/YYYY")} -
                            {moment(datemodified.end_date).format("MM/DD/YYYY")}</p>
                    </div>



                    <div className="leader-board-dropdown">


                        {
                            // userType == REVIEWADMIN && (
                            <div>
                                <Select
                                    showSearch
                                    className="custom-select"
                                    style={{ width: 230, fontSize: '12px' }}
                                    placeholder="Search Agency"
                                    optionFilterProp="children"
                                    allowClear
                                    value={selectedAgencies}
                                    onChange={(value) => {
                                        setRSFSCardFilters({
                                            selectedLeaderBoardAgency: value,
                                            selectedLeaderBoardUsers: []
                                        })
                                        setSelectedAgencies(value);
                                        setSelectedUsers([]);
                                        if (value === undefined || value.length === 0) {
                                            handleChange([], "Agency");
                                        } else {
                                            handleChange(value, "Agency");
                                        }
                                    }}
                                    filterOption={(input, option) => {
                                        if (!option || !option.props || !option.props.children) {
                                            return false;
                                        }
                                        return option.props.children.toLowerCase().includes(input.toLowerCase());
                                    }}
                                >
                                    {agencies.map((opt) => (
                                        <Option key={opt.name} value={opt.id} style={{ fontSize: '12px' }}>
                                            {opt.name}
                                        </Option>
                                    ))}
                                </Select>
                            </div>
                            // )
                        }


                        <div style={{ position: 'relative' }}>
                            <Select
                                mode="multiple"
                                showSearch
                                labelInValue
                                className="custom-select hide-selected-tags select-serach-dropdown"
                                // style={{ width: 230, height: 40, fontSize: '12px' }}
                                placeholder={placeholder}
                                value={selectedUsers}
                                notFoundContent={fetching ? 'Loading...' : null}
                                onSearch={(value) => setSearchText(value)}
                                onChange={(value) => {
                                    setSelectedUsers(value);
                                    const userIds = value.map(v => v.key);
                                    const userKeyLabelPairs = value.map(v => ({
                                        key: v.key,
                                        label: v.label
                                    }));
                                    handleChange(userIds, "User");
                                    setRSFSCardFilters({ selectedLeaderBoardUsers: userKeyLabelPairs });
                                    setUserOptions([]);
                                    setSearchText('');
                                }}
                                filterOption={false}
                                maxTagCount={0}
                                maxTagPlaceholder={null}
                            >
                                {userOptions.map((opt) => (
                                    <Option key={opt.id} value={opt.id} style={{ fontSize: '12px' }}>
                                        {opt.name}
                                    </Option>
                                ))}
                            </Select>
                            <Icon
                                type="search"
                                className='icon-style'
                                style={{ top: '40%', right: '13px' }}
                            />

                        </div>



                        <Button
                            type="primary"
                            className="bg-164897"
                            style={{ borderRadius: '20px' }}
                            onClick={() => refreshFilters()}
                        >
                            <Icon type="reload" />
                            Refresh
                        </Button>

                    </div>
                </div>

                {(selectedUsers && selectedUsers.length > 0) && (
                    <div style={{ marginTop: 10, display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                        {selectedUsers.map((user) => (
                            <div className="user-pill" key={user.key}>
                                {user.label}
                                <span
                                    role="button"
                                    tabIndex="0"
                                    style={{ marginLeft: 6, cursor: 'pointer', color: 'white' }}
                                    onClick={() => handleUserPillRemove(user)}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || e.key === ' ') {
                                            e.preventDefault();
                                            handleUserPillRemove();
                                        }
                                    }}
                                    aria-label={`Remove ${user.label}`}
                                >
                                    ×
                                </span>
                            </div>

                        ))}
                    </div>
                )}


                <Spin indicator={antIcon} spinning={loading}>
                    <ReusableAgGrid
                        ref={gridRef}
                        rowData={rowData}
                        columnDefs={columnDefs}
                        props={props}
                        customUserType={userType}
                        datemodified={datemodified}
                    />
                </Spin>
            </div>
        );
    });

export default LeaderBoard;



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/parts/review-admin/grid/LeaderBoard.js